import script from "./network-header-tips.vue?vue&type=script&lang=ts&setup=true"
export * from "./network-header-tips.vue?vue&type=script&lang=ts&setup=true"

import "./network-header-tips.vue?vue&type=style&index=0&id=fc73ac86&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc73ac86"]])

export default __exports__